import React from 'react'

import TownPlanningSidebar from './sidebar.component'

/*eslint-disable*/

interface Props {
  isTownplannig: boolean,
  colorsData: any,
  attributesData: any,
  handleSelectTownPlanningFilter: any
}

interface State {
  filteredAttributesData: any
}

class TownplanningContainer extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      filteredAttributesData: null
    }
  }

  componentDidMount(): void {
    var tempAttributes: any = []
    this.props.attributesData.map((attribute: any, index: number) => {
      if(attribute.type === 'Hierarchical'){
        tempAttributes.push(attribute)
      }
    })
    this.setState({
      filteredAttributesData: tempAttributes
    })
  } 

  render(): React.ReactNode {
      return(
        <div className={this.props.isTownplannig ? 'townplanning-container fade-in':'townplanning-container fade-out'}>
          {
            this.state.filteredAttributesData ? 
            <TownPlanningSidebar
              colorsData={this.props.colorsData}
              attributesData={this.state.filteredAttributesData}
              handleSelectTownPlanningFilter = {this.props.handleSelectTownPlanningFilter}
            />:null
          }
        </div>
      )
  }
}

export default TownplanningContainer